import React, { useMemo, memo } from 'react';
import FJConstant from '../../../../constants/FJConstant';
import FJPhotoRemoveBgDownload from '../view/FJPhotoRemoveBgDownload';
import { useSelector } from 'react-redux';
import FJActionPhotoBgRemover from '../../../../redux/action/FJActionPhotoBgRemover';
import { useDispatch } from 'react-redux';
import useLocalStore from '../../../../hooks/useLocalStore';
import FJPhotoRemoveBgRightHeaderButtons from './FJPhotoRemoveBgRightHeaderButtons.jsx';

const FJPhotoRemoveBgDownloadContainer = memo(function FJPhotoRemoveBgDownloadContainer() {
    useLocalStore();
    const dispatch = useDispatch();

    const brushEditStatus = useSelector(state => state.brushEditCommon.brushEditStatus);
    const isPhotoRemoveBg = useSelector(state => state.brushEditCommon.isPhotoRemoveBg);
    const curMenuIndex = useSelector(state => state.photoBgRemover.curMenuIndex);
    const customEditBgImageData = useSelector(state => state.photoBgRemover.customEditBgImageData);
    const headerTabIndex = useSelector(state => state.common.headerTabIndex);
    const thumbnailList = useSelector(state => state.photoBgRemover.thumbnailList);

    const isShow = useMemo(() => {
        return isPhotoRemoveBg && brushEditStatus === FJConstant.DEFAULT && headerTabIndex === FJConstant.CREATIONS;
    }, [isPhotoRemoveBg, brushEditStatus, headerTabIndex]);

    const downloadList = useMemo(() => {
        if (!isShow) return [];

        if (curMenuIndex === 0) {
            return thumbnailList.filter(item => item.status === FJConstant.SUCCESS);
        } else {
            return [customEditBgImageData];
        }
    }, [thumbnailList, curMenuIndex, customEditBgImageData, isShow]);

    const isShowDropdown = curMenuIndex === 0 && downloadList.length > 1;

    const handleAllClick = select => {
        dispatch(FJActionPhotoBgRemover.allDownloadListClickAction(select));
    };

    const handleItemClick = item => {
        dispatch(FJActionPhotoBgRemover.downloadListItemSelectAction(item));
    };

    const handleDownloadClick = () => {
        dispatch(FJActionPhotoBgRemover.downloadClickAction());
    };

    return window.isEditPage ? (
        <FJPhotoRemoveBgRightHeaderButtons />
    ) : (
        <FJPhotoRemoveBgDownload
            isShowDropdown={isShowDropdown}
            isShow={isShow}
            downloadList={downloadList}
            handleAllClick={handleAllClick}
            handleItemClick={handleItemClick}
            handleDownloadClick={handleDownloadClick}
        />
    );
});

export default React.memo(FJPhotoRemoveBgDownloadContainer);
